import { theme } from '@superhi/design';
import styled from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: -8px;

  @media ${theme.breakpoints.large} {
    margin: -12px;
  }

  > * {
    margin: 8px;

    @media ${theme.breakpoints.large} {
      margin: 12px;
    }
  }
`;
